import { postV2ApiAuthenticationFactorsFactorIdFinalize } from 'src/client/spendesk-api';
import { logger } from 'src/utils/datadog-log-wrapper';

export const postFinalizeUserAuthenticationFactorCreation = async ({
  factorId,
  token,
}: {
  factorId: string;
  token: string;
}): Promise<void> => {
  logger.debug(
    `Finalizing user authentication factors creation ${factorId} - ${token}`,
    {
      scope: 'user-authentication-factors',
      team: 'cards-ux',
    },
  );

  const response = await postV2ApiAuthenticationFactorsFactorIdFinalize({
    body: {
      token,
    },
    path: {
      factorId,
    },
  });

  if (response.statusCode !== 204) {
    logger.error(
      `Failed to finalize user authentication factor creation for factor ${factorId}.`,
      {
        error: response.body,
        scope: 'user-authentication-factors',
        team: 'cards-ux',
      },
    );
    throw new Error(
      `Failed to finalize user authentication factor creation for factor ${factorId}.`,
    );
  }
};
